// API types come from the official SDK; aliases avoid collisions with other services.
export type {
  AutoDeploymentMode as LambdaWebAutoDeploymentMode,
  FunctionSummary as LambdaWebFunctionSummary,
  ListWebFunctionsResponse,
  GetWebFunctionResponse,
  CreateWebFunctionRequest,
  RevisionConfig as LambdaWebRevisionConfig,
  EndpointConfig as LambdaWebEndpointConfig,
  CreateWebFunctionEndpointRequest,
  S3Object as LambdaWebS3Object,
  BuildConfig as LambdaWebBuildConfig,
  ServiceConfig as LambdaWebServiceConfig,
  FunctionRevisionSummary as LambdaWebRevisionSummary,
  GetWebFunctionRevisionResponse,
  CreateWebFunctionRevisionRequest,
  RevisionWeight as LambdaWebRevisionWeight,
  FunctionEndpointSummary as LambdaWebEndpointSummary,
  GetWebFunctionEndpointResponse,
  UpdateWebFunctionEndpointRequest,
} from '@aws-sdk/client-lambda-web';
